































import { Component, Mixins, Watch } from "vue-property-decorator";
import { TextItemOption, RollItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { RollObjectStyleReader } from "../styleReaders";
import {
  OptionSelectableStyledTextEditableObjectMixin,
  DataValidatableMixin
} from "./mixins";
import TextInputArea from "./TextInputArea.vue";
import { IFreeInputableObject } from "./IFreeInputableObject";

@Component({
  components: {
    TextInputArea,
  },
})
export default class RollObject extends Mixins(
  OptionSelectableStyledTextEditableObjectMixin,
  DataValidatableMixin
) implements IFreeInputableObject {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new RollObjectStyleReader(configuration.style.document.editor.objects.roll);
  }

  editingSource: RollItem;

  updateInputElement(value: HTMLInputElement): void {
    this.inputableElement = value;
  }

  @Watch("isFocused")
  updateIsFocused(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.adjustTextFontSize();
    }
  }

  @Watch("shouldInputFreeSelfOrAll")
  onShouldInputFreeUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue || this.isOptionSelected) { return; }
    this.applySelectedOption(this.findOptionToSelect());
  }

  private applySelectedOption(value: TextItemOption): void {
    const nextOption
      = this.shouldInputFreeSelfOrAll ? null
      : (value != null) ? value
      : this.options[0];
    if (this.selectedOption !== nextOption) {
      this.selectedOption = nextOption;
    }
  }

  inputClicked(): void {
    if (!this.shouldInputFreeSelfOrAll && !this.isEditDisabledByRuleSet) {
      this.rollToNextItem();
    }
    this.emitFocus();
  }

  rollToNextItem() {
    if (this.isOptionSelected) {
      this.applySelectedOption(this.options[(this.selectedOptionIndex + 1) % this.options.length]);
    } else {
      this.applySelectedOption(this.options[0]);
    }
  }

  get freeInputText(): string {
    this.updateTextPositionHeight();
    return this.label;
  }
  
  set freeInputText(value: string) {
    this.label = this.validateText(this.editingSource, value);
  }

  adjustTextFontSize(): void {
    if (!this.editingSource.isEmpty) {
      // TODO:複数行判定の仕様の確認
      this.autoAdjustFontSize();
    }
  }

  pasteText(value: string): void {
    this.insertTextToCaretPosition(value);
    this.$nextTick(() => {
      this.adjustTextFontSize();
    });
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }
}

